import React from "react";

import "./HighlightModeToggle.css";

const ICONS = {
  highlightBoth: "/assets/SVG-Icons/highligher.svg",
  highlightPersonal: "/assets/SVG-Icons/highlighter_personal.svg",
  highlightTeam: "/assets/SVG-Icons/highlighter_team.svg",
};

export const HIGHLIGHT_ORDER = ["both", "user", "team", "none"];

const MODE_LABELS = {
  both: "Show personal and team highlights",
  user: "Show personal highlights",
  team: "Show team highlights",
  none: "Hide highlights",
};

export const isValidHighlightMode = (mode) => HIGHLIGHT_ORDER.includes(mode);

function getHighlightIconSrc(mode) {
  switch (mode) {
    case "user":
      return ICONS.highlightPersonal;
    case "team":
      return ICONS.highlightTeam;
    case "both":
    case "none":
    default:
      return ICONS.highlightBoth;
  }
}

export default function HighlightModeToggle({
  mode = "both",
  onToggle,
  className = "",
  iconClassName = "",
  ariaLabel = "Change highlight mode",
  titlePrefix = "Highlight display",
}) {
  const normalizedMode = isValidHighlightMode(mode) ? mode : "both";
  const currentIndex = HIGHLIGHT_ORDER.indexOf(normalizedMode);
  const nextMode = HIGHLIGHT_ORDER[(currentIndex + 1) % HIGHLIGHT_ORDER.length];
  const title = `${titlePrefix}: ${MODE_LABELS[normalizedMode]}. Click to switch to ${MODE_LABELS[nextMode]}.`;

  return (
    <button
      type="button"
      className={`HighlightModeToggle ${normalizedMode === "none" ? "is-none" : ""} ${className}`.trim()}
      onClick={() => onToggle?.(nextMode)}
      aria-label={ariaLabel}
      title={title}
    >
      <img
        src={getHighlightIconSrc(normalizedMode)}
        alt=""
        className={`HighlightModeToggle__icon ${iconClassName}`.trim()}
        loading="eager"
        decoding="async"
      />
      {normalizedMode === "none" ? <span className="HighlightModeToggle__strike" aria-hidden="true" /> : null}
    </button>
  );
}
